export const getSeparatorsFromLocale = (locale: string) => {
  if (locale === 'fr') {
    return {
      thousandSeparator: ' ',
      decimalSeparator: ',',
    };
  }

  return {
    thousandSeparator: ',',
    decimalSeparator: '.',
  };
};
